<div class="text-slider">
  <swiper-container
    [attr.slides-per-view]="slidesPerView()"
    (swiperinit)="onSwiper($event)"
    center-insufficient-slides="true"
    >
    @for (item of items | async; track item) {
      <swiper-slide>
        <a
          class="text-slide"
          [href]="item.link"
          [ngClass]="{ 'small-text': item.title.length > 64 }"
          target="_parent"
          [attr.aria-label]="item.title"
          >
          <span>
            {{ item.title }}
          </span>
        </a>
      </swiper-slide>
    }
  </swiper-container>

  @if (swiper?.activeIndex != 0) {
    <button
      (click)="navigateTo(swiper.activeIndex - 1)"
      class="prev-btn"
      >
      <app-slider-arrow-icon direction="left"></app-slider-arrow-icon>
    </button>
  }
  @if (!swiper?.isEnd) {
    <button
      (click)="navigateTo(swiper.activeIndex + 1)"
      class="next-btn"
      >
      <app-slider-arrow-icon direction="right"></app-slider-arrow-icon>
    </button>
  }
</div>
<div class="pagination">
  @for (x of items | async; track x; let i = $index) {
    @if (
      i >= swiper?.activeIndex + slidesPerView() || i <= swiper?.activeIndex
      ) {
      <div
        class="indicator"
        [ngClass]="{ on: i == swiper?.activeIndex }"
        (click)="navigateTo(i)"
      ></div>
    }
  }
</div>
